document.addEventListener('readystatechange', event => {
    // When window loaded ( external resources are loaded too- `css`,`src`, etc...) 
    if (event.target.readyState === "complete") {
        initialLoaderBase();
    }
});

/**
 * La vista del loader inicial se oculta con una animación y despues de elimina el elemento del DOM.
 */
function initialLoaderBase()
{
    const element = document.getElementById('initial-loader');
    const bodyMain = document.getElementById('body-card');
    const preCardAll = document.getElementById('pre-card-all');
    
    if( !element ) return;

    element.classList.add('animate__animated', 'animate__fadeOutUpBig');

    element.addEventListener('animationend', () => {
        element.remove();                
    });

    if( bodyMain )
    bodyMain.classList.remove('hideInitLoad');

    if( preCardAll )
    preCardAll.classList.remove('hideInitLoad');
}